import Alert from '../Alert'
import { Link } from 'react-router-dom'
import { PageURLs } from '../../common'
import React, { FC, FormEventHandler, useState } from 'react'
import useAuth from '../../hooks/useAuth'
import { useDispatch } from 'react-redux'
import { logError, login } from '../../store/slices/app'
import axios from 'axios'

interface Props {
  className?: string
  onLogin?: () => void
}

const LoginForm: FC<Props> = ({ className = '', onLogin }) => {
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState('')

  const auth = useAuth()
  const dispatch = useDispatch()

  const handleFormSubmission: FormEventHandler<HTMLFormElement> = async (event) => {
    event.preventDefault()

    setError('')

    if (isLoading) {
      return
    }

    if (!email.trim() || !password) {
      setError('Please fill all required fields')

      return
    }

    setIsLoading(true)

    try {
      const { data } = await auth.requestToken(email, password)

      dispatch(login(data))

      onLogin?.()
    } catch (err) {
      dispatch(logError(err))
      if (axios.isAxiosError(err)) {
        setError(err.response?.data?.message || 'An unknown error occurred')
      }
      setIsLoading(false)
    }
  }

  return (
    <form className={className} onSubmit={handleFormSubmission} noValidate>
      {error ? <Alert type="danger" msg={error} /> : null}
      <div className="form-group">
        <label htmlFor="user_email" className="sr-only">
          Your Email
        </label>
        <input
          type="email"
          className="form-control form-control-lg"
          id="user_email"
          name="user_email"
          placeholder="Your Email"
          onInput={(e) => setEmail((e.target as HTMLInputElement).value.trim())}
          required
        />
      </div>
      <div className="form-group">
        <label htmlFor="user_pass" className="sr-only">
          Your Password
        </label>
        <input
          type="password"
          className="form-control form-control-lg"
          id="user_pass"
          name="user_pass"
          placeholder="Your Password"
          onInput={(e) => setPassword((e.target as HTMLInputElement).value.trim())}
          required
        />
        <Link to={PageURLs.PasswordEmail} className="reset-password-link float-right text-secondary pt-1 pb-3">
          <small>Forgotten your password?</small>
        </Link>
      </div>
      <button type="submit" className="btn btn-secondary btn-block border-0 btn-lg">
        {isLoading ? <div className="spinner-border text-light mr-2" role="status"></div> : null}
        <span>Login</span>
      </button>
    </form>
  )
}

export default LoginForm
